import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Card } from "../Card";
import { CloseIcon } from "../../components/Icons/CloseIcon";
import { ICON_SIZES, ICON_TYPES } from "../../constants/icons";

import "./styles.scss";

export const NPSSurveyWrapper = ({ children, className, dismissHandler }) => {
  return (
    <Card className={createClassNameString(["apti-CL NPSSurveyWrapper", className])}>
      <div className="NPSSurveyWrapper--dismiss_wrapper">
        <CloseIcon
          className="NPSSurveyWrapper--dismiss_icon"
          iconSize={ICON_SIZES.SMALL}
          iconType={ICON_TYPES.OUTLINE}
          onClick={dismissHandler}
        />
      </div>
      {children}
    </Card>
  );
};

NPSSurveyWrapper.propTypes = {
  className: PropTypes.string,
  dismissHandler: PropTypes.func.isRequired,
};

NPSSurveyWrapper.defaultProps = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: undefined,
  dismissHandler: () => {
    console.log("No Dismiss handler");
  },
};
